const FakeStore = {
    token: null,
    sessions: [],
    browserId: null,
};

export default FakeStore;
